export default __webpack_public_path__ + "static/media/gilroy-medium.86b8b07a.eot";